import React from "react"
export default function WeMakeProcessServingEasy() {
  return (
    <div className="container columns">
      <h2 className="column is-half">We make process serving easy:</h2>
      <div className="column is-half">
        <div className="icon-list-item">
          <img className="" alt="number one icon" src="assets/one-icon.svg" />
          <a href="assets/Process_Serving_Request_Form.docx" download><h3>Download and fill out this form</h3></a>
        </div>
        <div className="icon-list-item">
          <img className="" alt="number two icon" src="assets/two-icon.svg" />
          <a className="transition" href="mailto:service@prairieprocessserving.com"><h3 className="transition">Email it back to us</h3></a>
        </div>
      </div>
    </div>
  )
}